import {makeAutoObservable} from "mobx";

export default class HelperStore {
    constructor() {
        this._navBarHeight = false
        this._navigationHeight = false
        this._cookiesAccepted = false

        makeAutoObservable(this)
    }

    setNavBarHeight(data) {
        this._navBarHeight = data
    }

    setNavigationHeight(data) {
        this._navigationHeight = data
    }

    setCookiesAccepted(data) {
        this._cookiesAccepted = data
    }

    get navBarHeight() {
        return this._navBarHeight;
    }

    get navigationHeight() {
        return this._navigationHeight;
    }

    get cookiesAccepted() {
        return this._cookiesAccepted;
    }
}